<div class="container">

  <div class="input-container">
    <input [(ngModel)]="searchText" (input)="onSearchTermChange($any($event.target).value)" type="search">
    <!-- <img class="icon" src="assets/icons/Icon ionic-ios-search.svg"> -->
  </div>

  <app-table
    [items]="_data"
    [columns]="columns"
    class="table"
    [columnsSizes]="columnsSizes"
    [showHeader]="false"
    (checked)="checkedItem($event)"
  ></app-table>
</div>
